export default "https://storage.googleapis.com/prepweb-prod/dist/d196f5bd2dfa3bf4a927fd650323a0c3.png";